import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { isEmpty, checkNested } from 'srcReact/helpers/validator'
import {
  isWorkplaceManagerOfAtLeastOne,
  isWorkplaceManagerOfMany,
  isWorkplaceManagerOfOne
} from 'srcReact/helpers/userHelper'
import LogoutPopin from 'srcReact/components/popinsContent/LogoutPopin'
import { loginActions } from 'srcReact/LoginPage'

import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import Avatar from 'srcReact/components/common2/Avatar'

export default function MainMenu({ currentOrganization, user, isNative, user_properties }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [showLogoutPopup, setShowLogoutPopup] = useState(false)
  const [menuItems, setMenuItems] = useState([])

  useEffect(() => {
    setMenuItems(getMainMenuOptions())
  }, [])
  useEffect(() => {
    //render menu items again ,if there is any change in profile picture
    if (user.profile_picture) {
      setMenuItems(getMainMenuOptions())
    }
  }, [user?.profile_picture])

  const newInviteClick = () => {
    if (checkNested(currentOrganization, 'info', 'my_access', 'role_as_workplace_member')) {
      return `/0/workplace/settings/${currentOrganization.info.my_access.role_as_workplace_member.workplace_list[0]}?section=link_2`
    }
  }

  const workplacesClick = () => {
    if (checkNested(currentOrganization, 'info', 'my_access', 'role_as_workplace_member')) {
      return `/0/workplace/settings/${currentOrganization.info.my_access.role_as_workplace_member.workplace_list[0]}?section=link_1`
    }
  }

  const handleLogout = () => {
    dispatch(loginActions.userLogout())
  }

  const getMainMenuOptions = () => {
    const items = [
      { text: t('billing.upgrade'), icon: 'upgrade', href: '/0/support', className: styles.upgradeMenuItem },
      {
        text: t('nav.profile'),
        image: (
          <Avatar
            imgWrapperSize='small'
            userId={user.id}
            profilePicture={user.profile_picture}
            firstname={user.firstname}
            lastname={user.lastname}
            mimeType={user.mime_type}
            originalTag={user.original_tag}
            isOriginal={user.is_original}
            containerCSS={styles.profileImage}
          />
        ),
        href: `/0/profile/${user.id}`
      },
      {
        text: t('nav.member_directory'),
        icon: 'member-directory',
        href: '/0/member-directory'
      },
      {
        text: t('nav.my_invites'),
        icon: 'mail-opened',
        href: '/0/your-invites'
      }
    ]
    if (isWorkplaceManagerOfOne(currentOrganization) || isWorkplaceManagerOfMany(currentOrganization)) {
      items.push({
        text: t('nav.invite'),
        icon: t('nav.invite') && 'add-contact',
        href: newInviteClick()
      })
    }
    if (currentOrganization && !isEmpty(currentOrganization.info)) {
      items.push({
        text: t('nav.workplaces'),
        icon: t('nav.workplaces') && 'workplaces',
        href: workplacesClick()
      })
    }
    if (isWorkplaceManagerOfAtLeastOne(currentOrganization)) {
      items.push({
        text: t('nav.moderationCenter'),
        icon: t('nav.moderationCenter') && 'flag-icon',
        href: '/0/moderation?tab=workplace_activity'
      })
    }
    items.push({
      text: t('nav.settings'),
      icon: 'setting',
      href: '/0/settings/account'
    })
    if (currentOrganization && currentOrganization.info && currentOrganization.info.editable === true) {
      items.push({
        text: t('nav.orgaSettings'),
        icon: t('nav.orgaSettings') && 'organization',
        href: '/0/organization/settings'
      })
    }
    items.push({
      text: t('nav.help'),
      hasSubMenu: true,
      icon: 'help',
      className: styles.helpSubMenuItem,
      iconCSS: styles.helpIcon,
      options: [
        { text: t('nav.guidelines'), href: `${config.webUrl}/communities-at-work/community-guidelines` },
        { text: t('nav.about'), href: `${config.webUrl}/communities-at-work/learn-more/about` },
        { text: t('nav.blog'), href: `${config.webUrl}/blog/communities` },
        { text: t('nav.faq'), href: 'https://mixr-knowledge-base.mixr.net' },
        { text: t('contact.titleAuth'), href: '/0/support' }
      ]
    })
    items.push({
      text: t('nav.signout'),
      icon: 'logout',
      customMenuItemCSS: styles.signoutMenuItem,
      onClick: () => setShowLogoutPopup(true)
    })
    return items
  }
  if (!user_properties?.organization?.with_subscription) {
    const index = menuItems.findIndex((menu) => menu.name === t('billing.upgrade'))
    delete menuItems[index]
  }
  if (!user_properties?.workplace?.with_member_invitation) {
    const index = menuItems.findIndex((menu) => menu && menu.name === t('nav.invite'))
    delete menuItems[index]
  }

  return (
    <React.Fragment>
      <ReactMenu
        ariaLabel={t('formlabel.openMainMenu')}
        options={menuItems}
        buttonIcon='menu24'
        menuButtonCSS={styles.mainMenuDDButton}
        menuCSS={styles.mainMenuDDMenu}
        menuItemCSS={styles.mainMenuDDMenuItem}
        subMenuButtonCSS={styles.mainSubMenuDDButton}
        subMenuCSS={styles.mainMenuDDSubMenu}
      />
      {showLogoutPopup && (
        <LogoutPopin
          showLogout={showLogoutPopup}
          closeLogout={() => setShowLogoutPopup(false)}
          handleClick={() => handleLogout()}
        />
      )}
    </React.Fragment>
  )
}
